import React from 'react';
import { Receipt, FileText, Loader2, Plus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const BillingTab = ({
  billing, addonForm, setAddonForm, busyTenant, onAddAddon, onViewInvoice, onSetTenantOverageMode,
}) => (
  <Card className="bg-white border-slate-200">
    <CardHeader>
      <CardTitle className="text-slate-900 flex items-center gap-2">
        <Receipt className="w-5 h-5 text-indigo-700" /> Faturação & Denúncias Extra (mês atual)
      </CardTitle>
      <CardDescription className="text-slate-500">
        As denúncias são sempre recebidas. O excesso é contabilizado para faturação e alertas. Registe add-ons de denúncias extra por cliente.
      </CardDescription>
    </CardHeader>
    <CardContent>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="billing-table">
          <thead>
            <tr className="text-left text-slate-500 border-b border-slate-200">
              <th className="py-2 pr-4">Cliente</th>
              <th className="py-2 pr-4">Plano</th>
              <th className="py-2 pr-4">Denúncias</th>
              <th className="py-2 pr-4">Limite efetivo</th>
              <th className="py-2 pr-4">Excesso</th>
              <th className="py-2 pr-4">Modo</th>
              <th className="py-2 pr-4">Add-on extra</th>
              <th className="py-2 pr-4">Fatura</th>
            </tr>
          </thead>
          <tbody>
            {billing.map((b) => (
              <tr key={b.tenant_id} className="border-b border-slate-200" data-testid={`billing-row-${b.slug}`}>
                <td className="py-2 pr-4 text-slate-900">{b.name}<br /><span className="text-xs text-slate-500 font-mono">{b.slug}</span></td>
                <td className="py-2 pr-4 text-slate-600 capitalize">{b.plan}</td>
                <td className="py-2 pr-4 text-slate-600">{b.reports_count}</td>
                <td className="py-2 pr-4 text-slate-600">{b.unlimited ? '∞' : b.effective_limit}</td>
                <td className="py-2 pr-4">
                  {b.overage > 0
                    ? <span className="text-red-600 font-medium" data-testid={`overage-${b.slug}`}>+{b.overage}</span>
                    : <span className="text-green-500">0</span>}
                </td>
                <td className="py-2 pr-4">
                  <Select value={b.overage_mode} onValueChange={(v) => onSetTenantOverageMode(b.tenant_id, v)}>
                    <SelectTrigger className="h-8 w-44 bg-white border-slate-300 text-slate-900 text-xs" data-testid={`overage-mode-${b.slug}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="billing_only">Só faturação</SelectItem>
                      <SelectItem value="require_confirmation">Exigir confirmação</SelectItem>
                    </SelectContent>
                  </Select>
                </td>
                <td className="py-2 pr-4">
                  <div className="flex items-center gap-1">
                    <Input type="number" placeholder="+X" className="h-8 w-16 bg-white border-slate-300 text-slate-900 text-xs"
                      value={addonForm[b.tenant_id]?.extra || ''}
                      onChange={(e) => setAddonForm(prev => ({ ...prev, [b.tenant_id]: { ...prev[b.tenant_id], extra: e.target.value } }))}
                      data-testid={`addon-extra-${b.slug}`} />
                    <Input type="number" step="0.01" placeholder="€/un" className="h-8 w-20 bg-white border-slate-300 text-slate-900 text-xs"
                      value={addonForm[b.tenant_id]?.price || ''}
                      onChange={(e) => setAddonForm(prev => ({ ...prev, [b.tenant_id]: { ...prev[b.tenant_id], price: e.target.value } }))}
                      data-testid={`addon-price-${b.slug}`} />
                    <Button size="sm" disabled={busyTenant === b.tenant_id} onClick={() => onAddAddon(b.tenant_id)}
                      className="h-8 bg-indigo-700 hover:bg-amber-600 text-black px-2" data-testid={`addon-add-${b.slug}`}>
                      {busyTenant === b.tenant_id ? <Loader2 className="w-3 h-3 animate-spin" /> : <Plus className="w-3 h-3" />}
                    </Button>
                  </div>
                  {b.addon_extra > 0 && <span className="text-xs text-green-500">+{b.addon_extra} confirmadas</span>}
                </td>
                <td className="py-2 pr-4">
                  <Button size="sm" variant="outline" onClick={() => onViewInvoice(b.tenant_id)}
                    className="h-8 border-slate-300 text-slate-700 text-xs" data-testid={`invoice-${b.slug}`}>
                    <FileText className="w-3 h-3 mr-1" /> Ver
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CardContent>
  </Card>
);
